import React, { useState } from "react";
import { cn } from "../../utils/cn";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = React.forwardRef(({
  className,
  error,
  disabled,
  feedback, // to gracefully ignore PrimeReact's feedback prop
  toggleMask = true,
  inputStyle, // gracefully handle inline styles if passed
  ...props
}, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative w-full">
      <input
        ref={ref}
        type={showPassword ? "text" : "password"}
        disabled={disabled}
        className={cn(
          "w-full bg-urb-dark-surface border border-urb-border text-white text-sm rounded-lg px-3.5 py-2.5 pr-10 transition-colors placeholder:text-urb-text-muted/60 focus:outline-none focus:border-urb-primary focus:ring-1 focus:ring-urb-primary/30 disabled:opacity-50 disabled:cursor-not-allowed",
          error && "border-red-500/80 focus:border-red-500 focus:ring-red-500/20",
          className
        )}
        style={inputStyle}
        {...props}
      />
      {toggleMask && (
        <button
          type="button"
          tabIndex={-1}
          onClick={() => setShowPassword((prev) => !prev)}
          className="absolute inset-y-0 right-0 pr-3 flex items-center text-urb-text-muted hover:text-white transition-colors cursor-pointer bg-transparent border-none"
        >
          {showPassword ? (
            <EyeOff className="w-4 h-4" />
          ) : (
            <Eye className="w-4 h-4" />
          )}
        </button>
      )}
      {error && typeof error === "string" && (
        <span className="text-xs text-red-400 mt-1 block">{error}</span>
      )}
    </div>
  );
});

PasswordInput.displayName = "PasswordInput";
export default PasswordInput;
